import { useEffect } from 'react';
import { taskCollection } from './task-collection';
import { apiTaskToStoreTask } from './to-store';
/**
 * Drives AgGrid row updates from the task collection. When a task changes in
 * the collection (optimistic mutation, WS refetch, or a push from anywhere),
 * the matching visible grid row is updated with the fresh store-shaped value.
 *
 * This makes the server-side grid reactive to the collection — the single
 * source of truth — instead of needing bespoke per-source node updates.
 */ export const useTaskGridCollectionSync = (gridApi, fieldLookup)=>{
    useEffect(()=>{
        if (!gridApi) {
            return undefined;
        }
        return taskCollection.subscribeToChanges((changedIds)=>{
            if (!gridApi || gridApi.isDestroyed()) {
                return;
            }
            gridApi.forEachNode((node)=>{
                var _node_data;
                const id = (_node_data = node.data) === null || _node_data === void 0 ? void 0 : _node_data.taskId;
                if (id == null || !changedIds.has(id)) {
                    return;
                }
                const task = taskCollection.get(id);
                if (task) {
                    node.setData(apiTaskToStoreTask(task, fieldLookup));
                }
            });
        });
    }, [
        gridApi,
        fieldLookup
    ]);
};
